import { render } from "./LesRetraiteSpirituel.vue?vue&type=template&id=ff36f4e4&scoped=true&ts=true"
import script from "./LesRetraiteSpirituel.vue?vue&type=script&lang=ts"
export * from "./LesRetraiteSpirituel.vue?vue&type=script&lang=ts"

import "./LesRetraiteSpirituel.vue?vue&type=style&index=0&id=ff36f4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff36f4e4"]])

export default __exports__